import config from '@pb/kit-stylus/config.json';

const Typography = config.typography;

/**
 * Global classNames for typography variants
 * */
export const TypographyClasses = Object.keys(Typography).reduce((acc, name) => {
    // @ts-expect-error
    acc[name] = `typo-${name}`;
    return acc;
}, {} as Record<keyof typeof Typography, string>);
